import { createFileRoute, redirect } from "@tanstack/react-router";
import { CompetitorCompare } from "@/lib/lazyPages";
import { comparisons, comparisonSchemas } from "@/content/comparisons";
import { seoHead } from "@/lib/seo/head";

/** SERP descriptions get truncated past ~160 chars, so trim at a word boundary. */
function metaDescription(text: string, max = 155): string {
  if (text.length <= max) return text;
  const cut = text.slice(0, max);
  return `${cut.slice(0, cut.lastIndexOf(" ")).replace(/[,;:—-]$/, "")}…`;
}

export const Route = createFileRoute("/vs/$slug")({
  beforeLoad: ({ params }) => {
    if (params.slug !== "other-edtech-firms") {
      throw redirect({ to: "/vs/$slug", params: { slug: "other-edtech-firms" }, replace: true, statusCode: 301 });
    }
  },
  head: ({ params }) => {
    const data = comparisons[params.slug];
    if (!data) return seoHead({ title: "Comparison not found", noindex: true });
    return seoHead({
      title: data.seoTitle || `LeadXkids vs ${data.competitorName} — Honest Comparison`,
      description: metaDescription(data.summary),
      canonical: `/vs/${data.slug}`,
      ogType: "article",
      jsonLd: comparisonSchemas(data),
    });
  },
  component: CompetitorCompare,
});

